import { ProfileBlockResponseDto, ProfileBlocksResponseDto } from '@diritto/common/account/dtos/profile-block.dtos';
import { ResponseDto } from '@diritto/common/base/response.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class ProfileBlockApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async blockProfile(profileId: number) {
    const res = await this.http.post<undefined, ProfileBlocksResponseDto>(
      `${this.url}/accounts/profiles/${profileId}/block`,
    );
    return res.data;
  }

  async unBlockProfile(profileId: number) {
    const res = await this.http.delete<ResponseDto>(`${this.url}/accounts/profiles/${profileId}/block`);
    return res.data;
  }

  async getBlockProfile(profileId: number) {
    const res = await this.http.get<ProfileBlockResponseDto>(`${this.url}/accounts/profiles/${profileId}/block`);
    return res.data;
  }

  async findAllBlockProfile() {
    const res = await this.http.get<ProfileBlocksResponseDto>(`${this.url}/accounts/profiles/blocks`);
    return res.data;
  }
}
